import Delta from 'quill-delta';
import Quill from '../core/quill';
import Module from '../core/module';
import Block from '../blots/block';
import CodeBlock from '../formats/code';
import ListItem from '../formats/list';
import Figure from '../formats/figure';
import {getFigureValueByUrl} from '../formats/figure';
import icons from '../ui/icons';
import Gallery from '../formats/gallery';

const DEFAULT_BUTTONS = ['img', 'embed', 'toc', 'divider'];

class EmbedButtons extends Module {
  constructor(quill, options) {
    super(quill, options);
    const buttons = _.isArray(options) ? options : DEFAULT_BUTTONS;
    if (buttons.length) {
      this.initButtons(buttons);
    }
  }
  
  initButtons(buttons) {
    const container = document.createElement('div');
    const btnToggle = document.createElement('BUTTON');
    btnToggle.setAttribute('type', 'button');
    btnToggle.innerHTML = icons.interfacePack.plus;
    btnToggle.className = 'btn-toggle-controls';
    btnToggle.addEventListener('click', () => {
      this.container.classList.toggle('active');
      this.quill.focus();
    });
  
    const buttonsContainer = document.createElement('span');
    buttonsContainer.className = 'controls';
    
    this.addButtons(buttons, buttonsContainer);
    
    container.appendChild(btnToggle);
    container.appendChild(buttonsContainer);
  
    this.quill.container.appendChild(container);
    this.container = container;
  
    this.container.classList.add('ql-embed-buttons');
    this.container.classList.add('ql-hidden');
    this.container.style.position = 'absolute';
    this.controls = [];
    this.quill.on(Quill.events.EDITOR_CHANGE, (type, range) => {
      if (type === Quill.events.SELECTION_CHANGE) {
        this.update(range);
      }
    });
  
    window.addEventListener('resize', this.hideTooltip.bind(this));
  }
  
  addButtons(buttons, container) {
    buttons.forEach(name => {
      const fnName = 'add' + (name.charAt(0).toUpperCase() + name.slice(1)) + 'Button';
      const fn = this[fnName];
      fn && fn.bind(this)(container);
    });
  }
  
  addImgButton(buttonsContainer) {
    const btnImage = document.createElement('BUTTON');
    btnImage.setAttribute('type', 'button');
    btnImage.innerHTML = icons.interfacePack.image;
    btnImage.setAttribute('title', 'Вставить изображение');
    btnImage.addEventListener('click', this.handleImageBtnClick.bind(this));
    buttonsContainer.appendChild(btnImage);
  }
  
  addAsideButton(buttonsContainer) {
    const btnAside = document.createElement('BUTTON');
    const btnAsideTours = document.createElement('BUTTON');
    const btnAsideArticles = document.createElement('BUTTON');
    const btnAsideWebArticles = document.createElement('BUTTON');
    const btnAsidePrice = document.createElement('BUTTON');
    const btnAsideContainer = document.createElement('SPAN');
    
    btnAside.setAttribute('type', 'button');
    btnAside.innerHTML = icons.interfacePack.aside;
    btnAside.setAttribute('title', 'Блок с подсказкой справа');
    btnAside.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.insertEmbed(range.index, 'asideContainer', {}, Quill.sources.USER);
      this.container.classList.remove('active');
    });
  
    btnAsideTours.setAttribute('type', 'button');
    btnAsideTours.innerHTML = icons.interfacePack.asideTours;
    btnAsideTours.setAttribute('title', 'Блок с турами');
    btnAsideTours.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.insertEmbed(range.index, 'asideContainer', {
        content: '',
        aside: '<div class="aside-tours" data-selected="hidden-powers-and-northern-lights-hunt-winter-escorted-tour"></div>'
      }, Quill.sources.USER);
      this.container.classList.remove('active');
    });
  
    btnAsideArticles.setAttribute('type', 'button');
    btnAsideArticles.innerHTML = icons.interfacePack.asideArticles;
    btnAsideArticles.setAttribute('title', 'Блок со статьями');
    btnAsideArticles.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.insertEmbed(range.index, 'asideContainer', {
        content: '',
        aside: '<div class="aside-articles" data-selected="tupiki-v-islandii"></div>'
      }, Quill.sources.USER);
      this.container.classList.remove('active');
    });
  
    btnAsideWebArticles.setAttribute('type', 'button');
    btnAsideWebArticles.innerHTML = icons.interfacePack.asideWebArticles;
    btnAsideWebArticles.setAttribute('title', 'Блок со ссылками на Web-страницы');
    btnAsideWebArticles.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.insertEmbed(range.index, 'asideContainer', {
        content: '',
        aside: '<div class="aside-web-articles"><div data-url="https://example.com" data-title="Example.com" data-image="https://dummyimage.com/370x260/fff/aaa"></div></div>'
      }, Quill.sources.USER);
      this.container.classList.remove('active');
    });
  
    btnAsidePrice.setAttribute('type', 'button');
    btnAsidePrice.innerHTML = icons.interfacePack.asidePrice;
    btnAsidePrice.setAttribute('title', 'Блок с ценой');
    btnAsidePrice.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.insertEmbed(range.index, 'asideContainer', {
        content: '',
        aside: '<div class="aside-price"><span class="aside-numbers">350 €</span>минимальная цена за перелет в обе стороны</div>'
      }, Quill.sources.USER);
      this.container.classList.remove('active');
    });
  
    btnAsideContainer.classList.add('ql-btn-container');
    btnAsideContainer.appendChild(btnAside);
    btnAsideContainer.appendChild(btnAsideTours);
    btnAsideContainer.appendChild(btnAsideArticles);
    btnAsideContainer.appendChild(btnAsideWebArticles);
    btnAsideContainer.appendChild(btnAsidePrice);
    buttonsContainer.appendChild(btnAsideContainer);
  }
  
  addGalleryButton(buttonsContainer) {
    const btnGallery = document.createElement('BUTTON');
    const btnWww = document.createElement('BUTTON');
    const btnGalleryContainer = document.createElement('SPAN');
  
    btnGallery.setAttribute('type', 'button');
    btnGallery.innerHTML = icons.interfacePack.gallery;
    btnGallery.setAttribute('title', 'Галерея изображений');
    btnGallery.addEventListener('click', this.handleGalleryBtnClick.bind(this));
  
    btnWww.setAttribute('type', 'button');
    btnWww.innerHTML = icons.interfacePack.www;
    btnWww.setAttribute('title', 'Указать ссылки');
    btnWww.addEventListener('click', (e) => {
      e.preventDefault();
      const link = prompt('Введите ссылку на изображение');
      if (link !== null) {
        let range = this.quill.getSelection(true);
        this.quill.updateContents(new Delta()
            .retain(range.index)
            // .delete(prefix.length)
            .insert({gallery: [link]})
          , Quill.sources.USER);
        this.hideTooltip();
      }
    });
  
    btnGalleryContainer.classList.add('ql-btn-container');
    btnGalleryContainer.appendChild(btnGallery);
    btnGalleryContainer.appendChild(btnWww);
    buttonsContainer.appendChild(btnGalleryContainer);
  }
  
  addEmbedButton(buttonsContainer) {
    const btnEmbed = document.createElement('BUTTON');
    btnEmbed.setAttribute('type', 'button');
    btnEmbed.innerHTML = icons.interfacePack.embed;
    btnEmbed.setAttribute('title', 'Ссылка на видео');
    btnEmbed.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      let [line,] = this.quill.scroll.line(range.index);
      if (line) {
        let value = line.domNode.textContent;
        if (!value) {
          line.domNode.setAttribute('data-placeholder', 'Укажите ссылку на YouTube, Vimeo или на файл, и нажмите Enter');
          line.domNode.classList.add('placeholder_once');
          line.domNode.classList.add('empty');
          this.hideTooltip();
        }
      }
    });
    buttonsContainer.appendChild(btnEmbed);
  }
  
  addTocButton(buttonsContainer) {
    const btnToc = document.createElement('BUTTON');
    btnToc.setAttribute('type', 'button');
    btnToc.innerHTML = icons.interfacePack.toc;
    btnToc.setAttribute('title', 'Оглавление');
    btnToc.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.deleteText(range.index, 1, Quill.sources.SILENT);
      this.quill.insertEmbed(range.index, 'toc', true, Quill.sources.USER);
      this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
      this.container.classList.remove('active');
    });
    buttonsContainer.appendChild(btnToc);
  }
  
  addExcursionsButton(buttonsContainer) {
    const btnExcursions = document.createElement('BUTTON');
    btnExcursions.setAttribute('type', 'button');
    btnExcursions.innerHTML = icons.interfacePack.guide;
    btnExcursions.setAttribute('title', 'Блок экскурсий');
    btnExcursions.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.deleteText(range.index, 1, Quill.sources.SILENT);
      this.quill.insertEmbed(range.index, 'excursions', {limit: 3, editMode: true}, Quill.sources.USER);
      this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
      this.container.classList.remove('active');
    });
    buttonsContainer.appendChild(btnExcursions);
  }
  
  addDividerButton(buttonsContainer) {
    const btnDivider = document.createElement('BUTTON');
    btnDivider.setAttribute('type', 'button');
    btnDivider.innerHTML = icons.interfacePack.divider;
    btnDivider.setAttribute('title', 'Разделитель');
    btnDivider.addEventListener('click', (e) => {
      e.preventDefault();
      let range = this.quill.getSelection(true);
      this.quill.deleteText(range.index, 1, Quill.sources.SILENT);
      this.quill.insertEmbed(range.index, 'divider', true, Quill.sources.USER);
      this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
      this.container.classList.remove('active');
    });
    buttonsContainer.appendChild(btnDivider);
  }
  
  handleImageBtnClick(e) {
    e.preventDefault();
    this.hideTooltip();
    let fileInput = this.quill.container.querySelector('input.ql-image[type=file][data-status=ready]');
    if (fileInput === null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      fileInput.setAttribute('accept', 'image/gif, image/jpeg, image/jpg, image/png');
      fileInput.classList.add('ql-image');
      fileInput.addEventListener('change', () => {
        if (fileInput.files !== null && fileInput.files[0] !== null) {
          let file = fileInput.files[0];
          if (this.quill.fileSizeLimit && file.size > this.quill.fileSizeLimit) {
            return this.quill.fileSizeLimitCallback && this.quill.fileSizeLimitCallback();
          }
  
          let reader = new FileReader();
          reader.onload = (e) => {
            let figureValue = getFigureValueByUrl(e.target.result);
            if (figureValue) {
              let range = this.quill.getSelection(true);
              this.quill.updateContents(new Delta()
                  .retain(range.index)
                  .delete(range.length)
                  .insert({figure: figureValue}),
                Quill.sources.USER
              );
              this.hideTooltip();
              let [block] = this.quill.scroll.descendant(Figure, range.index);
              block.loading(true);
            } else {
              console.error('Invalid file format');
            }
            fileInput.value = '';
            fileInput.setAttribute('data-status', 'ready');
          };
          reader.readAsDataURL(file);
          
          this.uploadFileToCloud(file, xhr => {
            const range = this.quill.getSelection();
            const json = JSON.parse(xhr.responseText);
            const url = json.data['thumb'];
            this.quill.deleteText(range.index, 1, Quill.sources.SILENT);
            this.quill.insertEmbed(range.index, 'figure', {
              images: [url],
              source: json.data['secure_url']
            }, Quill.sources.SILENT);
  
            let [block] = this.quill.scroll.descendant(Figure, range.index);
            block.loading(false);
            block.focus();
          });
        }
      });
      this.quill.container.appendChild(fileInput);
    }
    fileInput.setAttribute('data-status', 'busy');
    fileInput.click();
  }
  
  handleGalleryBtnClick(e) {
    e.preventDefault();
    this.hideTooltip();
    let fileInput = this.quill.container.querySelector('input.ql-gallery[type=file][data-status=ready]');
    if (fileInput === null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      fileInput.setAttribute('accept', 'image/gif, image/jpeg, image/jpg, image/png');
      fileInput.setAttribute('multiple', 'true');
      fileInput.classList.add('ql-gallery');
      
      fileInput.addEventListener('change', () => {
        if (fileInput.files !== null && fileInput.files[0] !== null) {
          
          // создаем пустой блок галереи
          let range = this.quill.getSelection(true);
          this.quill.updateContents(new Delta()
            .retain(range.index)
            .delete(range.length)
            .insert({gallery: []}));
          let [gallery] = this.quill.scroll.descendant(Gallery, range.index);
          
          for (const file of fileInput.files) {
            if (this.quill.fileSizeLimit && file.size > this.quill.fileSizeLimit) {
              return this.quill.fileSizeLimitCallback && this.quill.fileSizeLimitCallback();
  
            }
            gallery.onUploadStart();
            this.uploadFileToCloud(file, xhr => {
              const json = JSON.parse(xhr.responseText);
              // const url = json.data['thumb'];
              gallery.onUploadSuccess();
              gallery.add(json.data['secure_url']);
            });
            
          }
        }
      });
      this.quill.container.appendChild(fileInput);
    }
    fileInput.setAttribute('data-status', 'busy');
    fileInput.click();
  }
  
  uploadFileToCloud(file, successCallback) {
    const fd = new FormData();
    const csrf = document.querySelector('meta[name="csrf-token"]');
    fd.append('image', file);
    fd.append('path', this.quill.container.dataset.id || '');
    csrf && fd.append('_csrf', csrf.content);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', API_DOMAIN + '/stories/upload', true);
    xhr.onload = () => {
      if (xhr.status === 200 && successCallback) {
        successCallback(xhr);
      }
    };
    xhr.send(fd);
  }

  showTooltip(range) {
    // console.log('show blocks tooltip');
    this.container.classList.remove('ql-hidden');
    this.blocksUpdatePosition(range);
  }
  
  hideTooltip() {
    // console.log('hide blocks tooltip');
    this.container.classList.add('ql-hidden');
    this.container.classList.remove('active');
  }
  
  blocksUpdatePosition(range) {
    if (typeof range === 'undefined') {
      range = this.quill.getSelection();
    }
    if (range === null || !this.quill) return;
    let lineBounds = this.quill.getBounds(range);
    this.container.style.left = (lineBounds.left - 38) + 'px';
    this.container.style.top = (lineBounds.top - 5) + 'px';
    // this.container.style.top = (lineBounds.top + lineBounds.height / 2) + 'px';
  }

  update(range) {
    if (!this.quill.isEnabled()) return;
    if (range === null) return;
    
    let [block] = this.quill.scroll.descendant(Block, range.index);
    if (range.length === 0) {
      if (block !== null &&
        !(block instanceof CodeBlock) &&
        !(block instanceof ListItem) &&
        !block.domNode.textContent.length) {
        this.showTooltip(range);
      } else {
        this.hideTooltip();
      }
    } else {
      this.hideTooltip();
    }
    
    checkOncePlaceholder(this);
  }
}

function checkOncePlaceholder(context) {
  const el = context.quill.root.querySelector('.placeholder_once');
  if (!el) return;
  el.removeAttribute('data-placeholder');
  el.classList.remove('placeholder_once');
  el.classList.remove('empty');
}

export {checkOncePlaceholder, EmbedButtons as default};
